<link
  rel="stylesheet"
  href="https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.css"
/>

<ng-template #onboarding>
  <!-- <div class="modal-header">
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div> -->
  <div class="modal-body p-0">
    <button
      type="button"
      class="pull-left position-absolute"
      aria-label="Close"
      (click)="modalRef.hide()"
      style="padding: 1rem; background: transparent; z-index: 999; border: 0"
    >
      <img src="/assets/img/on-boarding/modal-close.svg" alt="" />
    </button>
    <!-- Slider main container -->
    <div class="swiper">
      <!-- Additional required wrapper -->
      <div class="swiper-wrapper">
        <!-- Slides -->
        <div
          class="swiper-slide d-flex h-100 align-items-center justify-content-center bg-dark"
        >
          <div class="flex-column align-items-center justify-content-center">
            <lottie-player
              class="m-auto"
              src="/assets/animations/Lottie_Master_2_white.json"
              background="transparent"
              speed="1"
              style="width: 100%; height: 450px"
              loop
              autoplay
            ></lottie-player>
            <p class="p-5 text-center text-white">
              <strong
                >Siamo lieti di annunciare che Tutored si è trasformato in
                Joinrs!</strong
              >
              Un nuovo nome che riflette il nostro impegno nel rafforzare
              l’incontro tra aziende e giovani talenti affinché diventino new
              joiners dei propri team.Sappiamo che molti di voi sono stati con
              noi sin dal primo giorno, quindi speriamo che sarete entusiasti di
              questo cambiamento tanto quanto noi.
            </p>
          </div>
        </div>
        <div
          class="swiper-slide d-flex flex-column h-100 align-items-center justify-content-center"
        >
          <div
            class="flex-column align-items-center justify-content-between d-flex"
          >
            <p class="p-5 text-center mt-5">
              Tramite Joinrs potrete entrare in contatto con i talenti della Gen
              Z ma non solo. Infatti insieme a noi sta crescendo anche la nostra
              community e attraverso Joinrs sarà possibile attrarre e assumere
              anche profili junior, non più solo posizioni di stage e entry
              level.
            </p>
            <div>
              <img src="/assets/img/on-boarding/gen-z.png" alt="" />
            </div>
          </div>
        </div>
        <div
          class="swiper-slide d-flex flex-column h-100 align-items-center justify-content-center"
        >
          <div
            class="flex-column align-items-center justify-content-between d-flex"
          >
            <p class="p-5 text-center mt-5">
              <strong
                >Inoltre c’è una nuova funzionalità nel Pannello
                Employer!</strong
              ><br />
              Da oggi è possibile copiare e incollare un link esterno a una job
              offer e la nostra intelligenza artificiale creerà l’annuncio per
              te. L’AI ha l’obiettivo di aiutare i candidati nella comprensione
              degli annunci attraverso uno score di compatibilità dato sia dal
              percorso di studi che dagli elementi di attenzione/valori
              importanti per ogni persona.
            </p>
            <div class="mb-2">
              <img src="/assets/img/on-boarding/job-scraping.png" alt="" />
              <br />
            </div>
          </div>
        </div>
        <div
          class="swiper-slide d-flex flex-column h-100 align-items-center justify-content-center"
        >
          <div
            class="flex-column align-items-center justify-content-between d-flex"
          >
            <p class="p-5 text-center mt-5">
              Anche il processo di pubblicazione delle offerte di lavoro sarà
              molto più semplice e veloce: una volta copiato e incollato il link
              o il testo dell’annuncio di lavoro non dovrai selezionare nessun
              target o benefit, l’intelligenza artificiale farà tutto per te! Ma
              potrai semper modificare i dati prima di pubblicare.
            </p>
            <div>
              <img src="/assets/img/on-boarding/new-job.png" alt="" />
            </div>
          </div>
        </div>
      </div>

      <div class="swiper-pagination"></div>
    </div>
  </div>
</ng-template>
